import { HttpClient } from "@angular/common/http";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";

export interface IPexelsRes {
	page: number;
	per_page: number;
	photos: IPhotoPexels[];
	total_results: number;
}

export interface IPhotoPexels {
	id: number;
	width: number;
	height: number;
	url: string;
	photographer: string;
	photographer_url: string;
	photographer_id: number;
	avg_color: string;
	src: ISrcPexels;
	liked: boolean;
	alt: string;
}

export interface ISrcPexels {
	original: string;
	large2x: string;
	large: string;
	medium: string;
	small: string;
	portrait: string;
	landscape: string;
	tiny: string;
}

@Component({
	selector: "app-search-images-modal",
	templateUrl: "./search-images-modal.component.html",
	styleUrls: ["./search-images-modal.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class SearchImagesModalComponent {
	private dialogRef: MatDialogRef<SearchImagesModalComponent> = inject(MatDialogRef);
	private http: HttpClient = inject(HttpClient);

	searchControl: FormControl = new FormControl();

	pexelsRes$: Observable<IPexelsRes>;

	readonly pageSize = 40;
	currentPage = 1;

	loading: boolean;

	constructor() {}

	search(page = 1) {
		this.currentPage = page;
		const { value } = this.searchControl;
		if (!value) {
			return;
		}
		this.loading = true;
		this.pexelsRes$ = this.http
			.get<IPexelsRes>("https://api.pexels.com/v1/search", {
				headers: {
					Authorization:
						"563492ad6f91700001000001e69391c96203487a92c56eb48c2734b6",
				},
				params: {
					query: value,
					per_page: this.pageSize,
					page: this.currentPage,
				},
			})
			.pipe(finalize(() => (this.loading = false)));
	}

	close(res?) {
		this.dialogRef.close(res);
	}

	changePage({ length, pageSize, pageIndex }: PageEvent) {
		if (length > pageIndex * pageSize) this.search(pageIndex + 1);
	}

	pick(photo: IPhotoPexels) {
		this.close(photo);
	}
}
